module.exports = __webpack_public_path__ + "static/media/4ODA11.54f84c49.jpg";